import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastNotification } from '@carbon/react';

import { dismissToast } from '@/redux/new_services/toasts';
import './ToastStack.scss';

// In-house toast renderer. Subscribes to the toasts slice and renders one
// Carbon ToastNotification per active toast. Carbon's `timeout` prop is
// the heavy lifter: it sets an internal setTimeout that auto-hides the
// notification after the given ms. We piggyback on Carbon's `onClose`
// callback to also drop the entry from Redux so the array doesn't grow.
//
// The stack sits in a fixed top-right container; multiple toasts stack
// vertically. Mounted once at the app root via routes_loggedin.js — no
// portal needed since the container itself is `position: fixed`.
const TOAST_TIMEOUT_MS = 4000;

const ToastStack = () => {
  const items = useSelector((state) => state.toasts.items);
  const dispatch = useDispatch();

  if (!items || items.length === 0) return null;

  return (
    <div className="app-toast-stack">
      {items.map((toast) => (
        <ToastNotification
          key={toast.id}
          kind={toast.kind}
          title={toast.title}
          caption={toast.caption}
          timeout={TOAST_TIMEOUT_MS}
          onClose={() => {
            dispatch(dismissToast(toast.id));
            // Allow Carbon to finish its own hide-on-close handling.
            return true;
          }}
          onCloseButtonClick={() => dispatch(dismissToast(toast.id))}
        />
      ))}
    </div>
  );
};

export default ToastStack;
